import { CompanyPolicyRoleModel } from '../company-policy-role/companyPolicyRoleModel';
import { CompanyPolicyModel } from './companyPolicyModel';

export class CompanyPolicyViewModel extends CompanyPolicyModel{
    companyPolicyRoles: CompanyPolicyRoleModel[];
    currentVersion: string;
    roles: string;
}
